import { useContext, useEffect } from 'react';

import mixpanel from 'mixpanel-browser';

import { ApplicationContext } from '../contexts/Application';

export const useTrackStartFactFind = () => {
    const { applicationId } = useContext(ApplicationContext);

    useEffect(() => {
        const hasTracked = localStorage.getItem(
            `startFactFindTracked-${applicationId}`,
        );
        if (!hasTracked) {
            mixpanel.track('Start Fact Find');
            localStorage.setItem(
                `startFactFindTracked-${applicationId}`,
                'true',
            );
        }
    }, [applicationId]);
};
